import { RtbAPI } from "generated-api"

export enum CURRENCIES {
  CAD = "CAD",
  EUR = "EUR",
  USD = "USD"
}
export const ALL_CURRENCIES: CURRENCIES[] = [CURRENCIES.CAD, CURRENCIES.USD, CURRENCIES.EUR]

export type ICurrency = Awaited<ReturnType<typeof RtbAPI.getApiCurrencyList>>[0]

export interface ICurrencyRepository {
  getAllCurrencies(): Promise<ICurrency[]>
}

export interface ICurrencyState {
  currencies: ICurrency[]
}

export interface ICurrencyServiceState {
  cadExchangeRateByCurrencyId: { [key in CURRENCIES]: number }
}
